import { render, staticRenderFns } from "./CompareUpsellSheet.vue?vue&type=template&id=0b5731da&scoped=true&"
import script from "./CompareUpsellSheet.vue?vue&type=script&lang=js&"
export * from "./CompareUpsellSheet.vue?vue&type=script&lang=js&"
import style0 from "./CompareUpsellSheet.vue?vue&type=style&index=0&id=0b5731da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5731da",
  null
  
)

export default component.exports